import React, { createContext, useContext, useEffect, useState } from "react";
import * as api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.auth.me().then(setUser).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const u = await api.auth.login(email, password);
    setUser(u);
    return u;
  };

  const logout = () => {
    api.auth.logout();
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
